import * as R from 'ramda'
import { CaseType } from '@/modules/Case/interfaces/case'

export const caseType: {
  [key: string]: string;
} = {
  NEW_BUSINESS: 'New Business',
  RENEWAL: 'Renewal',
  REWRITE: 'Rewrite',
  REMARKET: 'Remarket',
  CANCELLATION: 'Cancellation',
  ENDORSEMENT: 'Endorsement',
  BOR: 'BOR'
}

export const caseTypeKeys = R.keys(caseType)
export const caseTypeValues = R.values(caseType)

export const caseStatus: {
  [key: string]: string;
} = {
  INQUIRY: 'Inquiry',
  QUOTE: 'Quote',
  UNDERWRITE: 'Underwrite',
  PROPOSAL: 'Proposal',
  BINDING: 'Binding',
  POST_BINDING: 'Post Binding',
  COMPLETED: 'Completed'
}

export const caseStatusKeys = R.keys(caseStatus)
export const caseStatusValues = R.values(caseStatus)

export const caseTypeClass: {
  [key: string]: string;
} = {
  REMARKET: 'c-case-type--remarket',
  BOR: 'c-case-type--bor',
  CANCELLATION: 'c-case-type--cancellation',
  RENEWAL: 'c-case-type--renewal',
  REWRITE: 'c-case-type--rewrite',
  ENDORSEMENT: 'c-case-type--endorsement',
  NEW_BUSINESS: 'c-case-type--new-business',
  COI: 'c-case-type--coi'
}

export const casePriorityClass: {
  [key: number]: string;
} = {
  1: 'c-case-priority--low',
  2: 'c-case-priority--medium',
  3: 'c-case-priority--high'
}

export function caseTypeToVerb (type: any): string {
  switch (type) {
    case CaseType.RENEWAL:
      return 'Renew'
    case CaseType.CANCELLATION:
      return 'Cancel'
    case CaseType.ENDORSEMENT:
      return 'Endorse'
    case CaseType.NEW_BUSINESS:
      return ''
    default:
      return caseType[type]
  }
}

export const casePriority: {
  [key: number]: string;
} = {
  3: 'High',
  2: 'Medium',
  1: 'Low'
}

export const casePriorityKeys = R.keys(casePriority)
export const casePriorityValues = R.values(casePriority)
